module.exports = __webpack_public_path__ + "static/img/tablet-main-img.c937cba7.svg";